export const ProviderEnum = {
  BEHAVIORAL: "BEHAVIORAL",
  BEHAVIORAL_INTAKE: "BEHAVIORAL_INTAKE",
  CARE_MANAGER: "CARE_MANAGER",
  CASE_MANAGER: "CASE_MANAGER",
  PCP: "PCP",
  PEER: "PEER",
  PRESCRIBE: "PRESCRIBE",
} as const;
